module.exports = __webpack_public_path__ + "img/enrtance-plant@3x.8d7cf0c2.webp";